<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Sku Actions</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="addButton" (click)="onAddSkuActionClick()">
                <ion-icon name="add"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Do these actions when a sku is purchased.
    </ion-list-header>

    <ion-list>
        @for (skuAction of allSkuActions; track $index) {
        <ion-item-sliding>
            <ion-item detail="true" (click)="onSkuActionClick(skuAction)">
                <ion-label>
                    <strong>{{skuAction.sku}} - {{skuAction.description}}</strong><br />
                    Actions: {{buildActionSummary(skuAction)}}
                </ion-label>
            </ion-item>
        </ion-item-sliding>
        }
    </ion-list>
</ion-content>